<template>
    <div class="video">
        <div class="container">
            <div class="videoContainer">
                <video id="play" :style="`height: ${videoHeight}px;`" controls preload="auto">
                    <source :src="videoList[0].src" type="video/mp4">
                </video>
                <div id="showChoose">
                    <img src="../assets/video/pop_icon_2x.png" @click="showSideBar">
                </div>
                <div id="overlay" v-show="ifShow">
                    <img src="../assets/video/push_icon_2x.png" @click="closeSideBar">
                    <div id="sidebar">
                        <span v-for="(item, idx) in videoList" :key="idx" class="options" @click="changeVideo($event, item.src)">{{item.title}}</span>
                    </div>
                </div>
            </div>
        </div>
        <myFooter></myFooter>
    </div>
</template>

<script>
import bus from '@/lib/bus.js'
export default {
    name: 'videoPage',
    data () {
        return {
            ifShow: false,
            // 在此处添加需要放置的视频
            // defaultVideo: require('../assets/video/test2.mp4'),
            // test1: require('../assets/video/test.mp4'),
            // test2: require('../assets/video/test2.mp4'),
            // test3: require('../assets/video/test3.mp4'),
            videoList: [
                {
                    title: '听障人士开会',
                    src: '/video/meeting.mp4'
                },
                {
                    title: '听障人士上课1',
                    src: '/video/class1.mp4'
                },
                {
                    title: '听障人士上课2',
                    src: '/video/class1.mp4'
                },
                {
                    title: '听障人士面对面聊天',
                    src: '/video/faceToFace.mp4'
                },
                {
                    title: '听障人士视频聊天',
                    src: '/video/videoChat.mp4'
                },
                {
                    title: '听障人士高效言语康复',
                    src: '/video/voiceTrain.mp4'
                },
                {
                    title: '听障人士看直播',
                    src: '/video/live.mp4'
                },
                {
                    title: '听障人士手语交友',
                    src: '/video/signLangChat.mp4'
                }
            ]
        }
    },
    computed: {
        videoHeight () {
            return window.innerHeight - 85
        }
    },
    mounted () {
        bus.$emit('changeSelectedIndex', 2)
		if (document.documentElement) {
			document.documentElement.scrollTop = 0
		} else {
			document.body.scrollTop = 0
		}
        document.getElementById('sidebar').children[this.$route.params.index].click()
    },
    methods: {
        showSideBar: function () {
            this.$set(this.$data, 'ifShow', true)
            document.getElementById('showChoose').style.display = 'none'
            document.getElementById('overlay').style.width = '30%'
            document.getElementById('overlay').style.left = '70%'
        },
        closeSideBar: function () {
            document.getElementById('overlay').style.width = '0'
            document.getElementById('overlay').style.left = '100%'
            this.$set(this.$data, 'ifShow', false)
            document.getElementById('showChoose').style.display = 'block'
        },
        changeVideo: function (evt, vUrl) {
            var spanOp = document.getElementsByClassName('options')
            for (var i = 0; i < spanOp.length; i++) {
                spanOp[i].style.color = 'white'
            }
            evt.currentTarget.style.color = '#F87030'

            let vdo = document.getElementById('play')
            vdo.src = vUrl
            vdo.play()
        }
    }
}
</script>

<style scoped>
.video{
    text-align: center;
}
.container{
    display: flex;
    display: -webkit-flex;
    justify-content: center;
}
.videoContainer{
    position:relative;
    text-align: center;
    width:90%;
}
.videoContainer img{
    position:absolute;
    left:0;
    top:50%;
    height:10%;
    z-index:10000;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
}
video{
    width:100%;
}
#showChoose{
    position: absolute;
    bottom: 0;
    left: 100%;
    right: 0;
    overflow: hidden;
    width: 0;
    height: 100%;
    transition: .5s ease;
}
.videoContainer:hover #showChoose{
    width:3%;
    left:97%;
}
#overlay{
    position: absolute;
    bottom: 0;
    left: 100%;
    right: 0;
    background-color: rgba(0,0,0,0.5);
    overflow: hidden;
    width: 0;
    height: 100%;
    transition: .5s ease;
}
#sidebar{
    height: 100%;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
#sidebar span{
    color: white;
    font-size:1.5em;
    font-weight: 500;
    line-height: 2.0;
    cursor: pointer;
}
#sidebar span:hover{
    width: 60%;
    background: url('../assets/video/choose_2x.png');
    background-repeat: no-repeat;
}
@media screen and (max-width:900px){
    #sidebar span{
        line-height: 1.5;
    }
}
@media screen and (max-width:600px){
    #sidebar span{
        font-size:1em;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Video.vue